import { useKindeAuth } from '@kinde-oss/kinde-auth-react'
import { Loader } from 'components/Loader'
import { LoginPage } from 'pages/login'
import React, { PropsWithChildren } from 'react'
import { Navigate } from 'react-router-dom'
import { useWpAuthContext } from 'services/auth/WpAuthProvider'
import { getLocalStorageData } from 'utils/localStorage'

export const ProtectedRoute: React.FC<PropsWithChildren> = ({ children }) => {
  const { isAuthenticated, isLoading } = useKindeAuth()

  const userSessionData = getLocalStorageData('user_data')

  if (isLoading) {
    return <Loader />
  }

  if (isAuthenticated) {
    if (userSessionData) {
      console.log('scenario 1')
      return <>{children}</>
    } else {
      console.log('scenario 2')
      return <Navigate to="/login" replace />
    }
  } else {
    console.log('scenario 3')
    return <Navigate to="/login" replace />
  }
}
